import React, { memo, useState } from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import FilterBlock from '../FilterBlock';
import './index.sass';

const { block, el } = bem('mobile-filter-block');
const MobileFilterBlock = memo(({ disabled }) => {
    const [ visible, setVisible ] = useState(false);

    const toggle = () => {
        setVisible(old => !old);
    }

    return <div className={ block({ disabled }) }>
        <div className={ el('show-text', { 'visible': visible }) } onClick={ toggle }>
            <Icon name={ 'funnel' }/>
            <Text>Фильтр</Text>
        </div>
        <div className={ el('hidden-part', { 'visible': visible }) }>
            <div className={ el('grid-inner') }>
                <FilterBlock/>
            </div>
        </div>
    </div>
})

export default MobileFilterBlock;
